var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Error") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Guide-Champion-WebSDK-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Champion_Notifications_Desktop",
    transform: "translate(-224.000000, -359.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Notification/error",
    transform: "translate(200.000000, 343.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/icon-alert-red",
    transform: "translate(24.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("g", {
    id: "bl-icon_error-red-medium",
    transform: "translate(0.000000, 1.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0053499,0 C16.6927573,0 17.3813499,0.449185185 17.9075721,1.34874074 L31.564461,27.5602963 C32.6038684,29.3463704 31.7209054,30.8148148 29.5887573,30.8148148 L2.4183869,30.8148148 C0.288609123,30.8148148 -0.613316803,29.3463704 0.442683197,27.5602963 L14.1007573,1.34874074 C14.6281647,0.449185185 15.3155721,0 16.0053499,0 Z",
    id: "Shape",
    fill: "#CF223F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2222222,18.272 L14.2222222,10.816 C14.2222222,9.83348148 15.0186667,9.03822222 16,9.03822222 C16.9813333,9.03822222 17.7777778,9.83348148 17.7777778,10.816 L17.7777778,18.272 C17.7777778,19.2533333 16.9813333,20.0497778 16,20.0497778 C15.0186667,20.0497778 14.2222222,19.2521481 14.2222222,18.272 Z M16.0106667,22.6962577 C14.8017778,22.6891852 13.8133333,23.6657778 13.8085658,24.8758519 C13.8026667,26.0882963 14.7816296,27.0755556 15.9917037,27.0802963 C17.202963,27.0885926 18.1902222,26.1096296 18.1925926,24.8995556 C18.2020741,23.6882963 17.2242963,22.6998519 16.0106667,22.6962577 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerDanger);
export default __webpack_public_path__ + "static/media/bannerDanger.6a841625247141d6a468a6dd0a3f96e5.svg";
export { ForwardRef as ReactComponent };